



































import Vue from 'vue';
import { cards } from '../main-page/constants';

export default Vue.extend({
  name: 'IntroCardsAnimation',

  data() {
    return {
      cards,
      isLoaded: false,
    };
  },
  mounted() {
    window.onload = () => {
      setTimeout(() => {
        requestAnimationFrame(() => {
          this.isLoaded = true;
        });
      }, 1000);
    };
  },
  methods: {
    classlist(name: string) {
      return [
        `intro-cards__card`,
        `animate__animated`,
        `animate__bounce`,
        `w100 items-center`,
        `intro-cards__card--${name.toLowerCase()}`,
        {
          isLoaded: this.isLoaded,
        },
      ];
    },
  },
});
